import type { NfseResumo, NfeResumo } from "../../../services/emissoesParaMeuCNPJ"

export type { NfseResumo, NfeResumo }

export type EmissoesParaMeuCNPJModel = {
    notasServico: NfseResumo[]
    notasMercadoria: NfeResumo[]
    mensagemServico?: string
    mensagemMercadoria?: string
    dataInicial: string
    dataFinal: string
}

function mesAnteriorInicio(): string {
    const d = new Date()
    d.setDate(1)
    d.setMonth(d.getMonth() - 1)
    return d.toISOString().split("T")[0]
}

function mesAnteriorFim(): string {
    const d = new Date()
    d.setDate(0)
    return d.toISOString().split("T")[0]
}

export const EmissoesParaMeuCNPJInicial: EmissoesParaMeuCNPJModel = {
    notasServico: [],
    notasMercadoria: [],
    dataInicial: mesAnteriorInicio(),
    dataFinal: mesAnteriorFim(),
}
